import { helpcenterApi } from '../../../api';
import {
  ArticleContext,
  CategoryContext,
} from '@wix/answers-common-components';
import { Article, Category } from '@wix/answers-api';

const getFormattedDate = (date: number) =>
  new Date(date).toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });

export const getArticleContextData = async (
  article: Article,
  locale: string,
  onFollow: (toggleFollow: boolean) => void,
): Promise<ArticleContext> => {
  const [isFollowing, counters] = await Promise.all([
    helpcenterApi.isFollowingArticle({
      id: article.id,
      locale,
    }),
    helpcenterApi.getArticleCounters({
      id: article.id,
      locale,
    }),
  ]);

  return {
    article,
    counters,
    updated: getFormattedDate(article.lastUpdateDate),
    created: getFormattedDate(article.creationDate),
    isFollowing,
    onFollowToggle: (toggleFollow) => {
      const apiCall = toggleFollow
        ? helpcenterApi.followArticle
        : helpcenterApi.unfollowArticle;

      onFollow(toggleFollow);
      return apiCall({ id: article.id, locale }).catch((e) => {
        onFollow(!toggleFollow);
        console.warn('Issue following article', e);
      });
    },
  };
};

export const getCategoryContextData = async (
  category: Category,
  locale: string,
  onFollow: (toggleFollow: boolean) => void,
): Promise<CategoryContext> => {
  const isFollowing = await helpcenterApi.isFollowingCategory({
    id: category.id,
    locale,
  });

  return {
    isFollowing,
    onFollowToggle: (toggleFollow: boolean) => {
      const apiCall = toggleFollow
        ? helpcenterApi.followCategory
        : helpcenterApi.unfollowCategory;

      onFollow(toggleFollow);
      return apiCall({ id: category.id, locale }).catch((e) => {
        onFollow(!toggleFollow);
        console.warn('Issue following category', e);
      });
    },
  };
};
